// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2I1dY","shimmer":"styles_shimmer__2FQcI"};